import { Injectable, signal } from '@angular/core';
import { Client } from '../../../models/clients.model';

@Injectable({
  providedIn: 'root',
})
export class ClientStateService {
  private readonly _state = signal<Client | null>(null);

  public readonly currentClient = this._state.asReadonly();

  setState(newState: Client) {
    this._state.set(newState);
  }

  updateState(newState: Partial<Omit<Client, '_id'>>) {
    const currentClient = this.currentClient();

    if (!currentClient) {
      return;
    }

    this._state.update(
      (currentState) =>
        ({
          ...currentState,
          ...newState,
        }) as Client
    );
  }

  clearState() {
    this._state.set(null);
  }
}
